module.exports = __webpack_public_path__ + "img/section1_phone.c40e6943.png";